<template>
  <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
  <base-notice-item
    button-text="Answer questions"
    :button-url="buttonUrl"
    status="Information missing"
  >
    <template #head>
      <strong>{{ $t('Your default answers for Worker Classification') }}</strong>
    </template>
    <template #icon>
      <img src="/gfx/worker-classification-logo-indigo.svg" />
    </template>
    <template #body>
      Your default answers to our questions related to Worker Classification will be applied to
      Worker Classification Recommendations (WCR) on new contracts in Worksome when applicable.
    </template>
  </base-notice-item>
</template>

<script>
/* eslint-disable import-x/extensions */
import gql from 'graphql-tag'
import RedirectUriMixin from '@/mixins/RedirectUriMixin'
import { laravelNamedRoute } from '@/utils/laravelNamedRoutes'
import namedRoutes from '@/utils/laravelNamedRoutes.json'

export const fragments = {
  account: gql`
    fragment UsWorkerClassificationFreelancerAlertAccount on Account {
      localId
    }
  `,
}

export default {
  name: 'UsWorkerClassificationFreelancerAlert',
  mixins: [RedirectUriMixin],
  props: {
    freelancer: {
      type: Object,
      required: true,
    },
  },
  computed: {
    buttonUrl() {
      return laravelNamedRoute(
        namedRoutes.determinations.edit,
        {
          determination: 'usWorkerClassification',
          context: 'freelancer',
          id: this.freelancer.localId,
          redirect_uri: this.redirectUri,
        },
        false,
      )
    },
  },
}
</script>
